<template>
	<div class="container-simple-table">
		<div class="header-table">
			<div class="left-side-container">
				<feather
					class="refreshtable"
					:class="loadingtable === true ? 'animation-refresh' : 'stop'"
					type="refresh-cw"
					size="18px"
					@click="!loadingtable ? modalSendData() : null"
				/>
				<Search width="70%" height="35px" @searchtext="modalSendData($event)" />
			</div>
			<div class="right-side-container">
				<div class="select-rows-qt">
					<select
						id=""
						v-model="rowsperpagechange"
						class="select-container"
						title="Selecionar quantidade de linhas"
						@change="rowsperpage = rowsperpagechange"
					>
						<option :value="10">
							10 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom}` }}
						</option>
						<option :value="30">
							30 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom}` }}
						</option>
						<option :value="50" selected>
							50 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom}` }}
						</option>
						<option :value="100">
							100 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom}` }}
						</option>
					</select>
				</div>
				<kfilter
					:filter-visibility="filterVisibility"
					@apply="modalSendData()"
					@open-filter="filterVisibility = true"
					@clear="clearFilter()"
				>
					<template v-slot:container>
						<div class="dateselect-container">
							<b-checkbox v-model="office" size="is-small" class="checkbox-date">
								Cargo
							</b-checkbox>
						</div>
						<div v-if="office" class="date-box">
							<treeselect v-model="officeSelected" :multiple="true" :options="setorOptions" />
						</div>
						<div class="dateselect-container">
							<b-checkbox v-model="state" size="is-small" class="checkbox-date">
								Estado
							</b-checkbox>
						</div>
						<div v-if="state" class="date-box">
							<treeselect v-model="stateSelected" :multiple="true" :options="states" />
						</div>
						<div class="dateselect-container">
							<b-checkbox v-model="gender" size="is-small" class="checkbox-date">
								Gênero
							</b-checkbox>
						</div>
						<div v-if="gender" class="date-box">
							<treeselect v-model="genderSelected" :multiple="true" :options="genders" />
						</div>
						<div class="dateselect-container">
							<b-checkbox v-model="possui_deficiencia" size="is-small" class="checkbox-date">
								Deficiência
							</b-checkbox>
						</div>
						<div v-if="possui_deficiencia" class="date-box">
							<treeselect
								v-model="deficienciaSelected"
								:multiple="true"
								:options="[
									{ label: 'Sim', id: 1 },
									{ label: 'Não', id: 0 },
								]"
							/>
						</div>
						<!-- <div class="dateselect-container">
							<b-checkbox v-model="formacao" size="is-small" class="checkbox-date">
								Formação
							</b-checkbox>
						</div>
						<div v-if="formacao" class="date-box">
							<treeselect
								v-model="formacaoSelected"
								:multiple="true"
								:options="[
									{ label: '1° Grau', id: '1° Grau' },
									{ label: '2° Grau', id: '2° Grau' },
									{ label: 'Superior', id: 'Superior' },
									{ label: 'Pos Graduação', id: 'Pos Graduação' },
									{ label: 'Mestrado', id: 'Mestrado' },
									{ label: 'Doutorado', id: 'Doutorado' },
								]"
							/>
						</div> -->
						<!-- <div class="dateselect-container">
							<b-checkbox v-model="especializacao" size="is-small" class="checkbox-date">
								Especialização
							</b-checkbox>
						</div>
						<div v-if="especializacao" class="date-box">
							<treeselect
								v-model="especializacaoSelected"
								:multiple="true"
								:options="[
									{ label: 'Pos Graduação', id: 'Pos Graduação' },
									{ label: 'Mestrado', id: 'Mestrado' },
									{ label: 'Doutorado', id: 'Doutorado' },
								]"
							/>
						</div> -->
						<div class="situation-box">
							<b-checkbox v-model="dataenviocheck" size="is-small" class="checkbox-situation">
								Data de Envio
							</b-checkbox>
							<div v-if="dataenviocheck" class="situation-box-input">
								<feather type="corner-down-right" size="18" class="arrow-indicator" />
								<div class="grouped-situation-input">
									<b-input
										v-model="dataenvio[0]"
										type="date"
										size="is-small"
										class="input-date-picker"
									/>
									<b-input
										v-model="dataenvio[1]"
										type="date"
										size="is-small"
										class="input-date-picker"
									/>
								</div>
							</div>
						</div>
					</template>
				</kfilter>
				<div>
					<Button
						title="Baixar"
						margin-left="15px"
						width="76px"
						height="36px"
						font-size="10px"
						:icon="{
							type: 'download',
							size: '12px',
							color: '#000000',
						}"
						:disabled="false"
						border-radius="5px"
						@click="multiplePDF()"
					/>
				</div>
				<div>
					<Button
						title="Gerar Planilha"
						margin-left="15px"
						width="76px"
						height="36px"
						font-size="10px"
						:icon="{
							type: 'file-text',
							size: '12px',
							color: '#000000',
						}"
						:disabled="false"
						border-radius="5px"
						@click="geraPlanilha()"
					/>
				</div>
			</div>
		</div>

		<b-table
			:data="isEmpty ? [] : data"
			:selected.sync="selected"
			:total-pages="mytotalPages"
			:current-page="currentpage !== 0 && currentpage !== undefined ? currentpage : 1"
			:total="totalPages"
			:paginated="isEmpty === false ? true : false"
			:per-page="rowsperpage"
			pagination-size="is-small"
			:loading="loadingtable"
			:sticky-checkbox="true"
			:checked-rows.sync="checkedRows"
			focusable
			backend-sorting
			backend-pagination
			checkable
			@sort="(orderby, direction) => modalSendData(null, orderby, direction)"
			@page-change="pagechange($event)"
		>
			<b-table-column
				v-slot="props"
				field="acoes"
				label="Ações"
				width="40"
				centered
				header-class="custom-header"
			>
				<b-dropdown aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="!props.row.cpf"
						:title="!props.row.cpf ? 'Você pode apenas baixar os currículo' : 'Ver Detalhes'"
						@click="$router.push(`details/${props.row.pessoa_id || props.row.id}`)"
					>
						<div class="menu-row-option">
							<feather class="menu-row-icon check" type="eye" size="16" />
							<h1>Ver detalhes</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						@click="
							props.row.cpf
								? exportPdf(props.row.pessoa_id || props.row.id)
								: downloadOldPdf(props.row.email)
						"
					>
						<div class="menu-row-option">
							<feather class="menu-row-icon check" type="arrow-down-circle" size="16" />
							<h1>Baixar currículo</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>
			</b-table-column>
			<!--       <b-table-column
        v-slot="props"
        field="pessoa_id"
        label="ID"
        header-class="custom-header"
        centered
      >
        <span class="table-title-cad">
          {{ (props.row.pessoa_id || props.row.id) }}
        </span>
      </b-table-column> -->
			<b-table-column
				v-slot="props"
				field="nome"
				label="Nome"
				width="150"
				header-class="custom-header "
				sortable
			>
				<h1 :ref="`a${props.row.pessoa_id || props.row.id}`" class="table-title-cad nome">
					{{ props.row.nome ? props.row.nome : '~' }}
				</h1>
			</b-table-column>
			<b-table-column v-slot="props" field="cpf" label="cpf" header-class="custom-header" centered>
				<span class="table-title-cad cpf">
					{{ props.row.cpf ? props.row.cpf : '~' }}
				</span>
			</b-table-column>
			<b-table-column v-slot="props" field="email" label="email" header-class="custom-header">
				<span class="table-title-cad email">
					{{ props.row.email ? props.row.email : '~' }}
				</span>
			</b-table-column>
			<b-table-column v-slot="props" field="telefone" label="telefone" header-class="custom-header">
				<span class="table-title-cad telefone">
					{{ formataNumeroTelefone(props.row.telefone) }}
				</span>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="created_at"
				label="Data de Envio"
				header-class="custom-header"
				centered
				sortable
			>
				<span class="table-title-cad cidade">
					{{ props.row.created_at ? dateTimeToBrasil(props.row.created_at) : '~' }}
				</span>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="estado"
				label="estado"
				header-class="custom-header"
				centered
				sortable
			>
				<span class="table-title-cad estado">
					{{ props.row.estado ? props.row.estado : '~' }}
				</span>
			</b-table-column>
			<b-table-column
				v-slot="props"
				field="cidade"
				label="cidade"
				header-class="custom-header"
				centered
				sortable
			>
				<span class="table-title-cad cidade">
					{{ props.row.cidade ? props.row.cidade : '~' }}
				</span>
			</b-table-column>
		</b-table>
		<Empty
			v-if="data.length <= 0 && loadingtable === false"
			message="Nenhum item encontrado"
			subtitle="Tente alterar os filtros"
		/>
	</div>
</template>

<script>
import * as XLSX from 'xlsx';
import moment from 'moment';
import Treeselect from '@riophae/vue-treeselect';
import cookie from 'vue-cookie';
import kfilter from '../filter/custom';
import Empty from '../empty/index';
import * as ecAxios from '../../../util/ecAxios';
import global from '../../../mixins/global';
import 'vue-context/src/sass/vue-context.scss';
import PdfExport from '../../../services/pdf-export';
import Button from '../buttons/Default';
import Search from '../search/index';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

require('jspdf-autotable');

export default {
	components: {
		kfilter,
		Empty,
		Search,
		Button,
		Treeselect,
	},
	mixins: [global],
	props: {
		data: {
			type: Array,
			default: () => [],
		},
		loadingtable: {
			type: Boolean,
			default: true,
		},
		labels: {
			type: Array,
			default: () => [],
		},
		totalPages: {
			type: Number,
			default: 0,
		},
		currentpage: {
			type: Number,
			default: 1,
		},
	},

	data() {
		return {
			direction: 'desc',
			token: cookie.get('admtoken'),
			orderby: 'created_at',
			office: false,
			officeSelected: null,
			searchTerm: null,
			dataenviocheck: false,
			state: false,
			dataenvio: ['', ''],
			stateSelected: null,
			checkedRows: [],
			states: [
				{ label: 'Acre', id: 'AC' },
				{ label: 'Alagoas', id: 'AL' },
				{ label: 'Amap\u00e1', id: 'AP' },
				{ label: 'Amazonas', id: 'AM' },
				{ label: 'Bahia', id: 'BA' },
				{ label: 'Cear\u00e1', id: 'CE' },
				{ label: 'Distrito Federal', id: 'DF' },
				{ label: 'Esp\u00edrito Santo', id: 'ES' },
				{ label: 'Goi\u00e1s', id: 'GO' },
				{ label: 'Maranh\u00e3o', id: 'MA' },
				{ label: 'Mato Grosso', id: 'MT' },
				{ label: 'Mato Grosso do Sul', id: 'MS' },
				{ label: 'Minas Gerais', id: 'MG' },
				{ label: 'Paran\u00e1', id: 'PR' },
				{ label: 'Para\u00edba', id: 'PB' },
				{ label: 'Par\u00e1', id: 'PA' },
				{ label: 'Pernambuco', id: 'PE' },
				{ label: 'Piau\u00ed', id: 'PI' },
				{ label: 'Rio Grande do Norte', id: 'RN' },
				{ label: 'Rio Grande do Sul', id: 'RS' },
				{ label: 'Rio de Janeiro', id: 'RJ' },
				{ label: 'Rond\u00f4nia', id: 'RO' },
				{ label: 'Roraima', id: 'RR' },
				{ label: 'Santa Catarina', id: 'SC' },
				{ label: 'Sergipe', id: 'SE' },
				{ label: 'S\u00e3o Paulo', id: 'SP' },
				{ label: 'Tocantins', id: 'TO' },
			],
			gender: false,
			genderSelected: null,
			possui_deficiencia: false,
			deficienciaSelected: null,
			formacao: false,
			formacaoSelected: null,
			especializacao: false,
			especializacaoSelected: null,
			isLoading: true,
			dados: [],
			genders: [
				{ label: 'Masculino', id: 'M' },
				{ label: 'Feminino', id: 'F' },
				{ label: 'Outro', id: 'O' },
			],
			filterVisibility: false,
			setorOptions: null,
			rowsperpage: 50,
			rowsperpagechange: 50,
			rowsperpageCustom: '',
			userPageStatus: 0,
			lastpage: null,
			pageRows: 0,
			selected: {},
			filename: 'semnome.pdf',
			mytotalPages: 0,
			planilha: []
		};
	},
	computed: {
		isEmpty() {
			if (this.data.length <= 0) {
				return true;
			}
			return false;
		},
	},
	watch: {
		rowsperpagechange() {
			this.pagechange(this.lastpage);
		},
		selected(e) {
			this.$nextTick(() => {
				this.checkedRows = [e];
				this.focustTable(`a${e.id}`);
			});
		},
	},
	created() {
		if (!localStorage.getItem('filter-curriculos')) {
			this.pagechange(1);
		} else {
			const store = JSON.parse(localStorage.getItem('filter-curriculos'));
			const {
				officeSelected,
				office,
				stateSelected,
				state,
				gender,
				dataenvio,
				dataenviocheck,
				genderSelected,
				deficienciaSelected,
				formacaoSelected,
				especializacaoSelected,
			} = store;
			this.officeSelected = officeSelected;
			this.office = office;
			this.stateSelected = stateSelected;
			this.state = state;
			this.gender = gender;
			this.dataenvio = dataenvio;
			this.dataenviocheck = dataenviocheck;
			this.genderSelected = genderSelected;
			this.deficienciaSelected = deficienciaSelected;
			this.formacaoSelected = formacaoSelected;
			this.especializacaoSelected = especializacaoSelected;
			this.modalSendData();
		}
	},
	mounted() {
		this.getOffice();
	},
	methods: {
		downloadOldPdf(email) {
			const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.EC_CURRICULOS}/download?token=${this.token}&email=${email}`;
			window.open(url, '_blank');
		},
		multiplePDF() {
			this.checkedRows.forEach((element) => {
				if (element.cpf) {
					this.exportPdf(element.id);
				} else {
					this.downloadOldPdf(element.email);
				}
			});
		},
		async geraPlanilha() {
			if (!this.checkedRows.length) {
				return;
			}

			this.planilha = [];

			const promises = this.checkedRows
				.filter((element) => element.cpf)
				.map((element) => this.getPlaninhaRow(element.pessoa_id ?? element.id));
			await Promise.all(promises);

			const worksheet = XLSX.utils.json_to_sheet(this.planilha);
			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, 'Planilha1');
			XLSX.writeFile(workbook, 'dados.xlsx');
		},

		parseAddres(data) {
			let dados = data;
			if (!dados.rua) {
				dados.rua = 'Não informado';
			}
			if (!dados.numero) {
				dados.numero = 'S/N';
			}
			if (!dados.cidade) {
				dados.cidade = 'não informado';
			}
			if (!dados.estado) {
				dados.estado = 'não informado';
			}
			if (!dados.cep) {
				dados.cep = '00000-000';
			}
			dados = `${dados.rua}, ${dados.numero}, ${dados.cidade}, ${dados.estado} - ${dados.cep}`;
			return dados;
		},
		parseContato(telefone, celular) {
			let contato = '';
			if (telefone) {
				contato = telefone;
			}
			if (celular) {
				contato = `${contato || 'Sem contato'} | ${celular}`;
			}
			return contato;
		},
		solveDateInterval(dtInital, dtFinal) {
			let solveInital = null;
			let solveFinal = null;
			if (dtFinal === 'A') {
				solveFinal = 'Atualmente';
			}
			if (dtFinal && dtFinal !== 'A') {
				solveFinal = this.dateToBrasil(dtFinal);
			}

			if (dtInital) {
				solveInital = this.dateToBrasil(dtInital);
			}

			const str = `${solveInital} até ${solveFinal}`;

			return str;
		},
		async exportPdf(id) {
			let data = null;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_CURRICULOS}/show`, {
					id,
				})
				.then((response) => {
					data = response.data.curriculo;
				})
				.catch((e) => {
					// eslint-disable-next-line no-console
					console.error(e);
				});
			// eslint-disable-next-line
			let { dados, exp, formacao, area } = data;
			// eslint-disable-next-line prefer-destructuring
			dados = dados[0];
			exp.forEach((experiencia) => {
				// eslint-disable-next-line no-param-reassign
				experiencia.intervalo = this.solveDateInterval(experiencia.dt_inicio, experiencia.dt_fim);
			});
			const localidade = {
				rua: dados.endereco || null,
				numero: dados.numero || null,
				cidade: dados.cidade || null,
				estado: dados.estado || null,
				cep: dados.cep || null,
			};
			dados.subtitlename = `${dados.nacionalidade}, ${dados.idade} anos, ${dados.estado_civil}`;
			dados.contato = this.parseContato(dados.telefone, dados.celular);
			dados.endereco = this.parseAddres(localidade);
			dados.pretensao = this.transformToBrl(dados.pretensao);
			dados.ultimo_salario = this.transformToBrl(dados.ultimo_salario);
			const pdf = new PdfExport({
				dados,
				exp,
				formacao,
				area,
			});
			pdf.exportCurriculo();
		},
		async getPlaninhaRow(id) {
			let data = [];
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_CURRICULOS}/show`, {
					id,
				})
				.then((response) => {
					data = response.data.curriculo;
				})
				.catch((e) => {
					// eslint-disable-next-line no-console
					console.error(e);
				});
			// eslint-disable-next-line
			let { dados, formacao, area } = data;
			// eslint-disable-next-line prefer-destructuring
			dados = dados[0];

			const planinhaRow = {
				nome: dados.nome,
				telefone: this.formataNumeroTelefone(dados.telefone),
				email: dados.email,
				idade: `${dados.idade} anos`,
				endereco: dados.endereco,
				escolaridade: '',
				cargo: '',
				dtinscricao: moment(dados.created_at).format('DD/MM/YYYY'),
			};

			planinhaRow.escolaridade = formacao
				.map((form) => `${form.formacao} ${form.situacao_formacao}`)
				.join(', ');

			planinhaRow.cargo = area
				.map((ar) => ar.area)
				.join(', ');

			const dadosConvertidos = [
				{
					Nome: planinhaRow.nome,
					Telefone: planinhaRow.telefone,
					Email: planinhaRow.email,
					Idade: planinhaRow.idade,
					Endereço: planinhaRow.endereco,
					Escolaridade: planinhaRow.escolaridade.trim(),
					Cargo: planinhaRow.cargo.trim(),
					'Data de inscrição': planinhaRow.dtinscricao,
				}
			];
			this.planilha.push(...dadosConvertidos);
		},
		async getOffice() {
			const response = await ecAxios
				.connection()
				.get(process.env.VUE_APP_API_ADM_EC + api.env.EC_SETORES);

			if (response.data.error === 0) {
				// response.data.setor.forEach((element) => {
				//   this.setorOptions.push({
				//     id: element.setor,
				//     label: element.setor,
				//   });
				// });

				this.setorOptions = response.data.setor.map((item) => ({
					id: item.setor,
					label: item.setor,
				}));
				// this.$nextTick(() => {
				//   this.officeSelected = this.setorOptions[0].id;
				// });
				// this.officeSelected = this.setorOptions[0].id;
			}
		},
		focustTable(refId = 'a139') {
			this.$refs[refId].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
		},
		clearFilter() {
			this.officeSelected = null;
			this.office = false;
			this.stateSelected = null;
			this.state = false;
			this.gender = false;
			this.dataenvio = ['', ''];
			this.dataenviocheck = false;
			this.genderSelected = null;
			this.deficienciaSelected = null;
			this.formacaoSelected = null;
			this.especializacaoSelected = null;
		},
		modalSendData(searchTerm = null, orderby = 'created_at', direction = 'desc') {
			this.checkedRows = [];
			this.orderby = orderby;
			this.direction = direction;
			if (searchTerm) {
				this.searchTerm = searchTerm.toUpperCase();
			} else {
				this.searchTerm = null;
			}
			const interval = {
				from: '',
				to: '',
			};
			if (!this.office) {
				this.officeSelected = null;
			}

			if (!this.state) {
				this.stateSelected = null;
			}

			if (!this.gender) {
				this.genderSelected = null;
			}
			if (!this.formacao) {
				this.formacaoSelected = null;
			}
			if (!this.especializacao) {
				this.especializacaoSelected = null;
			}
			if (!this.possui_deficiencia) {
				this.deficienciaSelected = null;
			}
			if (this.dataenvio[0] !== '' && this.dataenvio[1] !== '' && this.dataenviocheck === true) {
				// eslint-disable-next-line prefer-destructuring
				interval.from = this.dataenvio[0];
				// eslint-disable-next-line prefer-destructuring
				interval.to = this.dataenvio[1];
			} else {
				this.dataenvio = ['', ''];
				this.dataenviocheck = false;
			}
			const data = {
				officeSelected: this.officeSelected,
				office: this.office,
				stateSelected: this.stateSelected,
				state: this.state,
				gender: this.gender,
				possui_deficiencia: this.deficiencia,
				formacao: this.formacao,
				especializacao: this.especializacao,
				dataenvio: this.dataenvio,
				dataenviocheck: this.dataenviocheck,
				deficienciaSelected: this.deficienciaSelected,
				formacaoSelected: this.formacaoSelected,
				especializacaoSelected: this.especializacaoSelected,
				orderby: this.orderby,
				direction: this.direction,
			};
			localStorage.setItem('filter-curriculos', JSON.stringify(data));
			this.$emit('apply-modal', {
				offset: 0,
				limit: this.rowsperpagechange,
				area: this.officeSelected,
				estado: this.stateSelected,
				genero: this.genderSelected,
				possui_deficiencia: this.deficienciaSelected,
				formacao: this.formacaoSelected,
				especializacao: this.especializacaoSelected,
				interval,
				direction: this.direction,
				orderby: this.orderby,
				searchTerm: this.searchTerm,
			});
			this.filterVisibility = false;
		},

		pagechange(pagenumber) {
			const interval = {
				from: '',
				to: '',
			};
			if (this.dataenvio[0] !== '' && this.dataenvio[1] !== '' && this.dataenviocheck === true) {
				// eslint-disable-next-line prefer-destructuring
				interval.from = this.dataenvio[0];
				// eslint-disable-next-line prefer-destructuring
				interval.to = this.dataenvio[1];
			} else {
				this.dataenvio = ['', ''];
				this.dataenviocheck = false;
			}
			this.$emit(
				'pagechange',
				{
					direction: 'desc',
					orderby: 'created_at',
					offset: pagenumber * this.rowsperpagechange - this.rowsperpagechange,
					area: this.officeSelected,
					estado: this.stateSelected,
					genero: this.genderSelected,
					possui_deficiencia: this.deficienciaSelected,
					formacao: this.formacaoSelected,
					especializacao: this.especializacaoSelected,
					interval,
					searchTerm: this.searchTerm,
				},
				pagenumber
			);
			this.lastpage = pagenumber;
			this.rowsperpageCustom = pagenumber * this.rowsperpagechange + 1;
			this.userPageStatus = this.rowsperpageCustom - this.rowsperpagechange;
		},
		changeOption(e) {
			this.$emit('changeOption', e);
		},

		showContext(row, context) {
			this.selected = row;
			context.preventDefault();
			this.$refs.menu.open(context, row);
		},
	},
};
</script>

<style lang="scss" scoped>
.input-date-picker {
	width: 49% !important;
}
.grouped-situation-input {
	display: flex;
	width: 89%;
	justify-content: space-between;
}
.situation-box-input {
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin-top: 7px;
}
.situation-box {
	padding: 15px 15px 15px 0;
	border-bottom: 1px solid #6d5bd027;
	width: 100%;
	margin-bottom: 10px;
}
.circle {
	width: 5px;
	height: 5px;
	margin: 1px;
	border-radius: 50%;
	background-color: rgb(212, 212, 212);
	transition: ease-in-out 0.5s;
}
.row-actions-circles {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 10px;
}
.row-actions-circles:hover {
	cursor: pointer;
}
.row-actions-circles:hover .circle {
	background-color: rgb(139, 139, 139);
}

.checkbox-date {
	width: 100%;
	padding: 10px 10px 10px 0px;
	border-bottom: 1px solid rgba(204, 204, 204, 0.411);
}
.date-box {
	display: flex;
}
.input-date-picker {
	width: 45%;
	font-size: 5px;
}
.input-date-picker:first-child {
	margin-right: 8px;
}
.dateselect-container {
	margin-top: 20px;
	display: flex;
	flex-direction: row;
	width: 100%;
	justify-content: space-between;
	animation: all 1s ease-in;
}
.dateselectinput:first-child {
	margin-right: 10px;
}
.empty {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	flex-direction: column;
	transition: 0.5s ease-in-out;
}

.empty p {
	color: #25213b;
	font-weight: bold;
}
.img-empty {
	width: 35%;
}

.search-container {
	width: 60%;
	display: flex;
	align-items: center;
}

.refreshtable {
	margin-right: 20px;
	color: #00c9a7;
	cursor: pointer;
}

.animation-refresh {
	-webkit-animation: rotating 2s linear infinite;
	-moz-animation: rotating 2s linear infinite;
	-ms-animation: rotating 2s linear infinite;
	-o-animation: rotating 2s linear infinite;
	animation: rotating 2s linear infinite;
}

@keyframes rotating {
	from {
		-ms-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-webkit-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	to {
		-ms-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-webkit-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
.container-simple-table {
	margin-bottom: 30px;
	padding-bottom: 20px;
	background-color: #fff;
}

.left-side-container {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 50%;
}

.right-side-container {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	width: 50%;
}
.select-container {
	all: unset;
	width: 150px;
	border-radius: 0.25rem;
	cursor: pointer;
	margin-right: 20px;
	border: 1px solid #e2e2e2;
	padding-top: 7px;
	padding-bottom: 7px;
	padding-left: 15px;
	font-size: 12px;
	color: rgb(98, 98, 98);
}

.span-rounded {
	width: 50px;
	height: 50px;
	background-color: #25213b;
}
.header-table {
	display: flex;
	width: 100%;
	background-color: #fff;
	justify-content: space-between;
	padding: 20px;
}

.about-more {
	font-size: 12px;
	padding-left: 5px;
	padding-right: 5px;
	border-radius: 5px;
	color: #6e6893;
	font-weight: normal;
}

.int-id,
.email,
.user,
.id {
	font-size: 12px;
	font-weight: 400;
	color: #626262;
}
.table-title-cad {
	color: $row-color;
	font-weight: $row-weight;
	margin-top: 5px;
	margin-bottom: 2px;
	font-size: $row-size;
}
.email,
.nome {
	text-align: left;
}
.nome,
.cidade,
.uf {
	text-transform: uppercase;
}

.custom-header {
	font-size: $header-size;
	font-weight: $header-weight;
	color: $header-color;
}

/* .tag-status {

    color: #FFF;

} */

.is-success {
	display: flex;

	align-items: center;
}

.menu-row-icon {
	color: #8b83ba;

	padding-left: 10px;

	padding-right: 10px;

	font-weight: 500;
}

.menu-row-box-bottom {
	padding-top: 10px;
}

.menu-row-box {
	padding-bottom: 10px;

	border-bottom: 1px solid #f2f0f9;
}

.menu-row-option:first-child {
	margin-top: 5px;
}

/* .menu-row-option:hover {
  background-color: #f2f0f9 !important;

  color: #25213b !important;

  border-radius: 5px;
} */

.menu-row-option:hover .danger {
	color: #dc3545 !important;
}

.menu-row-option:hover .check {
	color: #007f00;
}

.menu-row-option:hover .archive {
	color: #f77f00;
}

.menu-row-option {
	display: flex;
	align-items: center;
	margin-left: 5px;
	margin-right: 5px;
	padding: 10px;
	cursor: pointer;
}

.right-container {
	display: flex;
}

.actions-table:hover {
	color: #25213b !important;
	border-radius: 5px;
}

.actions-table:hover .danger {
	color: #dc3545 !important;
}

.actions-table:hover .check {
	color: #007f00;
}

.actions-table:hover .archive {
	color: #f77f00;
}

.actions-table .menu-row-icon {
	padding-right: unset;
}

.actions-table {
	cursor: pointer;
	align-items: center;
	justify-content: center;
	display: flex;
	margin-left: 10px;
	padding-top: 4px;
	padding-bottom: 4px;
	padding-right: 7px;
	padding-left: 7px;
	font-size: 12px;
	line-height: 1.5;
	border-radius: 0.25rem;
	border: 1px solid #e2e2e2;
}
</style>
>

